import { useMemo } from "react";
import { ZoneWithCells } from "../../types";

export const useDimension = (
  containerWidth: number,
  containerHeight: number,
  zone: ZoneWithCells,
  gutter: number,
) =>
  useMemo(() => {
    const zoneWidth = zone.maxX - zone.minX;
    const zoneHeight = zone.maxY - zone.minY;
    const scaleX = (containerWidth - gutter * 2) / zoneWidth;
    const scaleY = (containerHeight - gutter * 2) / zoneHeight;
    let scale = scaleY;
    let offsetX = 0;
    let offsetY = 0;
    if (scaleX < scaleY) {
      scale = scaleX;
      offsetY = (containerHeight - (zoneHeight * scale + gutter * 2)) / 2;
    } else {
      offsetX = (containerWidth - (zoneWidth * scale + gutter * 2)) / 2;
    }
    return [scale, offsetX, offsetY];
  }, [containerHeight, containerWidth, gutter, zone.minX, zone.maxX, zone.minY, zone.maxY]);
